import { Card, CardBody, CardFooter, CardHeader } from "@patternfly/react-core";

export interface TestingLocationCardProps {
  name: string;
  address: string;
  contact: string;
}

export function TestingLocationCard(props: TestingLocationCardProps) {
  return (
    <Card isFullHeight>
      <CardHeader>{props.name}</CardHeader>
      <CardBody>{props.address}</CardBody>
      <CardFooter>{props.contact}</CardFooter>
    </Card>
  );
}
